import { render, staticRenderFns } from "./skills.vue?vue&type=template&id=5ba336d6&scoped=true&"
import script from "./skills.vue?vue&type=script&lang=js&"
export * from "./skills.vue?vue&type=script&lang=js&"
import style1 from "./skills.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba336d6",
  null
  
)

export default component.exports